// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { RoutingS } from '../../../../Service/RoutingS';
import { BookitupNotification } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';

const InvoiceNotPaid: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { personDescription, eventId, entityId } = notification;

  return (
    <Text>
      Das{' '}
      <LinkText span weight="bolder" onClick={() => RoutingS.openInNewTab(`/events/${eventId}/documents/${entityId}`)}>
        Rechnung
      </LinkText>{' '}
      für
      <Text span weight="bolder">
        {` ${personDescription} `}
      </Text>
      ist überfällig.
    </Text>
  );
};

export default InvoiceNotPaid;
